/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import settings from './store-settings'
import analytics from './store-analytics'
import theme from './store-theme'
import alert from './store-alert'
import report from './store-customReport'
import admin from './store-admin'

Vue.use(Vuex)

export default new Vuex.Store({
  state: mutations.initialState,
  mutations,
  getters,
  actions,
  modules: {
    settings,
    analytics,
    theme,
    alert,
    report,
    admin
  },
  plugins: [createPersistedState()]
})
